import { Button, Card, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import {
  SortingDirection,
  WttpQuestionnaireResponsesDocument,
  WttpQuestionnaireResponsesQuery,
} from 'src/graphql/generated/graphql';
import { useQuery } from '@apollo/client';
import { WttpQuestionnaireCard } from '../questionnaire-responses/list/card/card';
import { Routes } from 'src/components/common/router/constants';
import { Link } from 'src/components/common/link';

export const WttpSurveys = () => {
  const { t } = useTranslation();

  const { data, refetch } = useQuery<WttpQuestionnaireResponsesQuery>(
    WttpQuestionnaireResponsesDocument,
    {
      variables: {
        filter: {
          isActive: true,
        },
        pagination: {
          limit: 5,
          offset: 0,
        },
        sorting: {
          updatedAt: SortingDirection.Desc,
        },
      },
    },
  );

  if (!data) {
    return null;
  }

  const questionnaireResponses = data.wttpQuestionnaireResponses.records;

  return (
    <Card noBorder className="flex flex-col w-full bg-white">
      <Typography variant="subtitle1" className="mb-1 font-bold">
        {t('wttp.configuration.cards.recent-assignments.title')}
      </Typography>
      <Typography variant="subtitle2">
        {t('wttp.configuration.cards.recent-assignments.description')}
      </Typography>

      <div className="mt-2">
        {questionnaireResponses?.map((questionnaireResponse) => (
          <WttpQuestionnaireCard
            key={questionnaireResponse.id}
            questionnaireResponse={questionnaireResponse}
            buttonVariant="icon"
            onClose={() => {
              refetch();
            }}
          />
        ))}
      </div>
      {questionnaireResponses?.length && (
        <Link
          to={Routes.wttpQuestionnaireResponses.path}
          className="flex justify-end"
        >
          <Button>{t('common.see-all')}</Button>
        </Link>
      )}
    </Card>
  );
};
